var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.counts.hasOwnProperty(_vm.group))?_c('span',{staticClass:"boldFont",domProps:{"textContent":_vm._s(`(${_vm.counts[_vm.group][_vm.slug]})`)}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }